module.exports = __webpack_public_path__ + "img/3x.d94a789.jpg";